export type QuizShareImages = Partial<Record<'story' | 'feed', string>>;

export interface PersonalityQuizResult {
  title: string;
  desc: string;
  shareTitle: string;
  shareHook: string;
  typeKey: string;
  variantKey?: string;
  percent: number;
  answers: Record<number, string>;
  shareImages?: QuizShareImages;
}

export interface SingleQuizResult {
  title: string;
  desc: string;
  shareTitle: string;
  shareHook: string;
  typeKey: string;
  variantKey?: string;
  percent: number;
  temperature: string;
  temperatureLabel: string;
  triggerTagD: boolean;
  tagDSupplement?: string;
  answers: Record<number, string>;
  shareImages?: QuizShareImages;
}

export interface ExtraDetailsData {
  additionalAnswers?: Record<string, string>;
  personalityResult?: PersonalityQuizResult | null;
  singleResult?: SingleQuizResult | null;
  bedroomResult?: any | null; // Bedroom Config 18+
}

export function parseExtraDetails(raw: unknown): ExtraDetailsData | null {
  if (!raw) return null;
  try {
    const parsed = typeof raw === 'string' ? JSON.parse(raw) : raw;
    if (!parsed || typeof parsed !== 'object') return null;
    return parsed as ExtraDetailsData;
  } catch {
    return null;
  }
}

/** Ưu tiên kết quả quiz trên máy (guest vừa làm) rồi mới lấy từ server */
export function mergeExtraDetails(
  local: ExtraDetailsData | undefined,
  server: ExtraDetailsData | null
): Required<Pick<ExtraDetailsData, 'additionalAnswers' | 'personalityResult' | 'singleResult'>> {
  const fromServer = server || {};
  const fromLocal = local || {};
  return {
    additionalAnswers: {
      ...(fromServer.additionalAnswers || {}),
      ...(fromLocal.additionalAnswers || {}),
    },
    personalityResult: fromLocal.personalityResult ?? fromServer.personalityResult ?? null,
    singleResult: fromLocal.singleResult ?? fromServer.singleResult ?? null,
  };
}

export function hasQuizResults(ext: ExtraDetailsData | null | undefined): boolean {
  return Boolean(ext?.personalityResult || ext?.singleResult);
}

export function applyQuizShareImage(
  ext: ExtraDetailsData | undefined,
  quizType: 'personality' | 'single' | 'bedroom',
  aspectRatio: 'story' | 'feed',
  imageUrl: string
): ExtraDetailsData {
  const base = ext || {};
  const resultKey = quizType === 'personality' ? 'personalityResult' : quizType === 'single' ? 'singleResult' : 'bedroomResult';
  const current = base[resultKey];
  if (!current) return base;

  return {
    ...base,
    [resultKey]: {
      ...current,
      shareImages: {
        ...(current.shareImages || {}),
        [aspectRatio]: imageUrl,
      },
    },
  };
}